import SignalRConnector from './signalr-connector';

export default SignalRConnector;